export const RSP_TYPE = {
  ROCK: 'rock',
  SCISSORS: 'scissors',
  PAPER: 'paper',
} as const;

export type RSP_TYPE_KEY = keyof typeof RSP_TYPE;

export type RSP_TYPE_VALUE = typeof RSP_TYPE[RSP_TYPE_KEY];

export const BATTLE_TYPE_MAP = {
  [RSP_TYPE.ROCK]: '바위',
  [RSP_TYPE.SCISSORS]: '가위',
  [RSP_TYPE.PAPER]: '보',
};

export const RSP_ICON_MAP = {
  [RSP_TYPE.ROCK]: '✊',
  [RSP_TYPE.SCISSORS]: '✌',
  [RSP_TYPE.PAPER]: '✋',
};

export const battleTypeList = Object.keys(BATTLE_TYPE_MAP).map((key) => {
  return {
    key: key,
    value: BATTLE_TYPE_MAP[key],
  };
});
